// Service 27 — ทรัพย์สินทางปัญญา (เครื่องหมายการค้า · ลิขสิทธิ์ · สิทธิบัตร · ความลับทางการค้า · GI)
// อ้างอิงหลัก: กรมทรัพย์สินทางปัญญา (ipthailand.go.th),
// พ.ร.บ.เครื่องหมายการค้า พ.ศ. 2534 และที่แก้ไขเพิ่มเติม (ฉบับที่ 3) พ.ศ. 2559,
// พ.ร.บ.ลิขสิทธิ์ พ.ศ. 2537 และที่แก้ไขเพิ่มเติม, พ.ร.บ.สิทธิบัตร พ.ศ. 2522 และที่แก้ไขเพิ่มเติม,
// พ.ร.บ.ความลับทางการค้า พ.ศ. 2545, พ.ร.บ.คุ้มครองสิ่งบ่งชี้ทางภูมิศาสตร์ พ.ศ. 2546,
// พิธีสารมาดริด (ไทยมีผลผูกพัน 7 สิงหาคม 2560) และสนธิสัญญาความร่วมมือด้านสิทธิบัตร PCT (ไทยมีผลผูกพัน 24 ธันวาคม 2552) — WIPO (wipo.int),
// กรมการกงสุล (consular.mfa.go.th) สำหรับรับรองคำแปลและนิติกรณ์เอกสารมอบอำนาจจากต่างประเทศ
// Client-safe definitions only. ไม่ระบุราคาบริการในเนื้อหา

export type IpFaqCategory =
  | "trademark-registration"
  | "madrid-international"
  | "trademark-opposition"
  | "copyright-recordation"
  | "patent-invention"
  | "petty-patent-design"
  | "trade-secret-gi"
  | "ip-poa-documents";

export interface IpCategoryDef {
  slug: IpFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const IP_FAQ_CATEGORIES: IpCategoryDef[] = [
  {
    slug: "trademark-registration",
    titleTh: "จดทะเบียนเครื่องหมายการค้าในประเทศไทย",
    titleEn: "Registering a trademark in Thailand",
    descTh:
      "ขั้นตอนยื่นคำขอต่อกรมทรัพย์สินทางปัญญาตามพระราชบัญญัติเครื่องหมายการค้า พ.ศ. 2534 การตรวจค้นความเหมือนคล้าย การจำแนกจำพวกสินค้าและบริการตามระบบนีซ อายุความคุ้มครองสิบปี และการต่ออายุ",
    descEn:
      "Filing with the Department of Intellectual Property under the Trademark Act B.E. 2534, similarity searching, Nice classification of goods and services, the ten-year term of protection and renewal.",
    matchTh: /เครื่องหมายการค้า|จำพวก|นีซ|ตรวจค้น|ต่ออายุเครื่องหมาย|เครื่องหมายบริการ/,
    matchEn: /trademark|trade mark|nice class|classification|renewal of the mark|service mark/i,
  },
  {
    slug: "madrid-international",
    titleTh: "ยื่นเครื่องหมายการค้าระหว่างประเทศผ่านพิธีสารมาดริด",
    titleEn: "International trademark filing through the Madrid Protocol",
    descTh:
      "การใช้ประเทศไทยเป็นสำนักงานต้นทางเพื่อยื่นคำขอระหว่างประเทศต่อองค์การทรัพย์สินทางปัญญาโลก การกำหนดประเทศปลายทาง หลักการพึ่งพาคำขอพื้นฐานห้าปี และการยื่นตรงต่อประเทศที่ไม่เป็นภาคี",
    descEn:
      "Using Thailand as office of origin for an international application at WIPO, designating countries, the five-year dependency on the basic mark, and direct national filing in non-member countries.",
    matchTh: /มาดริด|ระหว่างประเทศ|WIPO|ประเทศปลายทาง|คำขอพื้นฐาน/i,
    matchEn: /madrid|international application|WIPO|designat|basic (mark|application)/i,
  },
  {
    slug: "trademark-opposition",
    titleTh: "คำสั่งนายทะเบียน การคัดค้าน อุทธรณ์ และเพิกถอน",
    titleEn: "Registrar orders, opposition, appeal and cancellation",
    descTh:
      "การแก้คำสั่งปฏิเสธของนายทะเบียน การคัดค้านคำขอที่ประกาศโฆษณา การอุทธรณ์ต่อคณะกรรมการเครื่องหมายการค้า การเพิกถอนเพราะไม่ใช้เครื่องหมาย และการฟ้องต่อศาลทรัพย์สินทางปัญญาและการค้าระหว่างประเทศกลาง",
    descEn:
      "Responding to a registrar's refusal, opposing a published application, appealing to the Trademark Board, cancellation for non-use, and litigation before the Central Intellectual Property and International Trade Court.",
    matchTh: /คัดค้าน|อุทธรณ์|เพิกถอน|ปฏิเสธ|คณะกรรมการเครื่องหมายการค้า|ศาลทรัพย์สินทางปัญญา|ละเมิด/,
    matchEn: /opposition|oppose|appeal|cancellation|refusal|trademark board|IP court|infringe/i,
  },
  {
    slug: "copyright-recordation",
    titleTh: "ลิขสิทธิ์ การแจ้งข้อมูล และการโอนสิทธิ",
    titleEn: "Copyright, recordation and assignment",
    descTh:
      "ลิขสิทธิ์เกิดขึ้นทันทีเมื่อสร้างสรรค์งานตามพระราชบัญญัติลิขสิทธิ์ พ.ศ. 2537 การแจ้งข้อมูลลิขสิทธิ์ต่อกรมทรัพย์สินทางปัญญาเพื่อเป็นพยานหลักฐาน อายุความคุ้มครอง สัญญาโอนสิทธิและอนุญาตให้ใช้สิทธิ",
    descEn:
      "Copyright arises on creation under the Copyright Act B.E. 2537, voluntary recordation at the Department of Intellectual Property as evidence, the term of protection, and assignment or licence agreements.",
    matchTh: /ลิขสิทธิ์|แจ้งข้อมูล|โอนสิทธิ|อนุญาตให้ใช้สิทธิ|งานสร้างสรรค์|ซอฟต์แวร์/,
    matchEn: /copyright|recordation|assignment|licen[cs]e agreement|work of authorship|software/i,
  },
  {
    slug: "patent-invention",
    titleTh: "สิทธิบัตรการประดิษฐ์และการยื่นผ่าน PCT",
    titleEn: "Invention patents and PCT filing",
    descTh:
      "เงื่อนไขความใหม่และการประดิษฐ์ขึ้นสูงตามพระราชบัญญัติสิทธิบัตร พ.ศ. 2522 อายุคุ้มครองยี่สิบปีนับแต่วันยื่น การขอให้ตรวจสอบการประดิษฐ์ และการเข้าสู่ระยะชาติของคำขอ PCT ในประเทศไทย",
    descEn:
      "Novelty and inventive-step requirements under the Patent Act B.E. 2522, the twenty-year term from the filing date, requesting substantive examination, and national-phase entry of a PCT application in Thailand.",
    matchTh: /สิทธิบัตรการประดิษฐ์|PCT|ระยะชาติ|ความใหม่|ตรวจสอบการประดิษฐ์|ยี่สิบปี/i,
    matchEn: /invention patent|PCT|national phase|novelty|substantive examination|twenty[- ]year/i,
  },
  {
    slug: "petty-patent-design",
    titleTh: "อนุสิทธิบัตรและสิทธิบัตรการออกแบบผลิตภัณฑ์",
    titleEn: "Petty patents and design patents",
    descTh:
      "ความต่างระหว่างอนุสิทธิบัตรกับสิทธิบัตรการประดิษฐ์ อายุคุ้มครองอนุสิทธิบัตรหกปีและต่อได้สองครั้งครั้งละสองปี สิทธิบัตรการออกแบบผลิตภัณฑ์สิบปี และการเลือกระบบให้เหมาะกับผลิตภัณฑ์",
    descEn:
      "How a petty patent differs from an invention patent, the six-year petty-patent term renewable twice for two years each, the ten-year design-patent term, and choosing the right route for a product.",
    matchTh: /อนุสิทธิบัตร|การออกแบบผลิตภัณฑ์|สิทธิบัตรการออกแบบ|หกปี|สิบปี/,
    matchEn: /petty patent|design patent|industrial design|six[- ]year|ten[- ]year design/i,
  },
  {
    slug: "trade-secret-gi",
    titleTh: "ความลับทางการค้าและสิ่งบ่งชี้ทางภูมิศาสตร์",
    titleEn: "Trade secrets and geographical indications",
    descTh:
      "การรักษาข้อมูลการค้าที่ยังไม่เปิดเผยตามพระราชบัญญัติความลับทางการค้า พ.ศ. 2545 สัญญารักษาความลับกับพนักงานและคู่ค้า และการขึ้นทะเบียนสิ่งบ่งชี้ทางภูมิศาสตร์ตามพระราชบัญญัติคุ้มครองสิ่งบ่งชี้ทางภูมิศาสตร์ พ.ศ. 2546",
    descEn:
      "Protecting undisclosed commercial information under the Trade Secrets Act B.E. 2545, confidentiality agreements with staff and partners, and registering a geographical indication under the Geographical Indications Protection Act B.E. 2546.",
    matchTh: /ความลับทางการค้า|รักษาความลับ|NDA|สิ่งบ่งชี้ทางภูมิศาสตร์|GI/i,
    matchEn: /trade secret|confidentiality|NDA|geographical indication|GI registration/i,
  },
  {
    slug: "ip-poa-documents",
    titleTh: "หนังสือมอบอำนาจ เอกสารบริษัท และคำแปลสำหรับงานทรัพย์สินทางปัญญา",
    titleEn: "Powers of attorney, corporate documents and translations for IP filings",
    descTh:
      "หนังสือมอบอำนาจของผู้ขอที่อยู่ต่างประเทศ การรับรองลายมือชื่อโดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสาร การรับรองเอกสารบริษัทต่างชาติ และการรับรองคำแปลก่อนยื่นต่อกรมทรัพย์สินทางปัญญา",
    descEn:
      "Powers of attorney for applicants resident abroad, signature certification by a notarial services attorney, certification of foreign corporate documents, and certified translation before filing at the Department of Intellectual Property.",
    matchTh: /หนังสือมอบอำนาจ|มอบอำนาจ|รับรองลายมือชื่อ|รับรองคำแปล|นิติกรณ์|หนังสือรับรองบริษัท|ตัวแทน/,
    matchEn: /power of attorney|signature certification|certified translation|legalis|legaliz|company affidavit|local agent/i,
  },
];

export function getIpCategoryDef(slug: string): IpCategoryDef | undefined {
  return IP_FAQ_CATEGORIES.find((c) => c.slug === slug);
}
